import styles from "./SpeakButton.module.css";
import { ReactComponent as SpeakerIcon } from "../../img/iconImgAllSpeaker.svg";
import { ReactComponent as SpeakerAbledIcon } from "../../img/iconImgAllSpeakerAbled.svg";

interface SpeakButtonProps {
  fontSize: "small" | "medium" | "large";
  isPlaying: boolean;
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export default function SpeakButton(props: SpeakButtonProps) {
  function handleOnClickButton(e: React.MouseEvent<HTMLDivElement>) {
    e.stopPropagation();
    props.onClick(e);
  }

  function getIconSize(): string {
    switch (props.fontSize) {
      case "small":
        return "24px";
      case "medium":
        return "32px";
      case "large":
        return "40px";
    }
  }

  return (
    <>
      <div
        className={styles.button}
        onClick={handleOnClickButton}
        style={{
          color: props.isPlaying
            ? "var(--icon-active-color)"
            : "var(--icon-secondary-color)",
        }}
      >
        {props.isPlaying ? (
          <SpeakerAbledIcon
            className={styles.icon}
            style={{
              width: getIconSize(),
              height: getIconSize(),
            }}
          />
        ) : (
          <SpeakerIcon className={styles.icon} />
        )}
      </div>
    </>
  );
}
